import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import ImportExportIcon from "@mui/icons-material/ImportExport";

export default function DropDown(props) {
  const theme = useTheme();

  const handleSelect = (e) => {
    if (e.target.value === "Release Date") {
      props.sortByFn("releaseDate");
    } else {
      props.sortByFn("viewCount");
    }
  };

  return (
    <div>
      <FormControl sx={{ height: "2px" }}>
        <Select
          className="sortBy"
          id="sort-select"
          displayEmpty
          onChange={handleSelect}
          input={<OutlinedInput />}
          renderValue={(selected) => {
            if (!selected) {
              return (
                <em>
                  <div style={{ display: "flex" }}>
                    <ImportExportIcon className="importExport" /> Release Date
                  </div>
                </em>
              );
            }

            return (
              <div style={{ display: "flex" }}>
                <ImportExportIcon className="importExport" /> {selected}
              </div>
            );
          }}
          inputProps={{ "aria-label": "Without label" }}
        >
          <MenuItem id="release-date-option" value="Release Date">
            Release Date
          </MenuItem>
          <MenuItem id="view-count-option" value="View Count">
            View Count
          </MenuItem>
        </Select>
      </FormControl>
    </div>
  );
}

// localchanges
